import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * 色付きアクセントカード（WorkflowColorCard ベース）。
 * params: title（必須）、text（joined, 説明）、color（任意, テーマトークン or カラーコード）、badge（任意）
 */
export const Card: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const title = (node.params.title as string) ?? '';
  const text = (node.params.text as string) ?? '';
  const color = (node.params.color as string) || 'primary.main';
  const badge = node.params.badge as string | undefined;

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        borderTop: 3,
        borderTopColor: color,
        p: 2,
        height: '100%',
      }}
    >
      <Stack spacing={0.5}>
        {badge && (
          <Box
            sx={{
              display: 'inline-block',
              px: 1,
              py: 0.25,
              borderRadius: 1,
              bgcolor: 'action.selected',
              color,
              fontSize: '0.65rem',
              fontWeight: 700,
              width: 'fit-content',
            }}
          >
            {badge}
          </Box>
        )}
        <Typography variant="body2" fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="caption" color="text.secondary" component="div">
          {renderInline(text)}
        </Typography>
      </Stack>
    </Box>
  );
};

export default Card;
